var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('Breadcrumb'),_c('div',{staticClass:"edit-content"},[_c('div',{staticClass:"form-box"},[_c('moral-form')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }